{
    "ELxOt9ohu37dBHoOT8WdV": {
        "position": {
            "x": 17,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/hammercavalier",
        "jobKey": "hammercavalier",
        "affiliation": "bad",
        "key": "ELxOt9ohu37dBHoOT8WdV"
    },
    "4VU0G6W3VLRV0h3lfO5ST": {
        "position": {
            "x": 12,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/spearknight",
        "jobKey": "spearknight",
        "affiliation": "bad",
        "key": "4VU0G6W3VLRV0h3lfO5ST"
    },
    "cZF2n9Gprb4xUYCG8b9Hy": {
        "position": {
            "x": 11,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "cZF2n9Gprb4xUYCG8b9Hy"
    },
    "ne4tD8YNqT_CSIkGSqgDz": {
        "position": {
            "x": 18,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "ne4tD8YNqT_CSIkGSqgDz"
    },
    "bridge1": {
        "position": {
            "x": 10,
            "y": 14,
            "z": 1
        },
        "affiliation": "inanimate",
        "key": "bridge1",
        "imageKey": "wall",
        "maxhealth": 30
    },
    "bridge2": {
        "position": {
            "x": 19,
            "y": 15,
            "z": 1
        },
        "affiliation": "inanimate",
        "key": "bridge2",
        "imageKey": "wall",
        "maxhealth": 30
    }
}
